import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#EC8C22" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.447716 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V17C18 17.5523 17.5523 18 17 18H1C0.447716 18 0 17.5523 0 17V1ZM8 5.5C8 5.22386 8.22386 5 8.5 5H9.5C9.77614 5 10 5.22386 10 5.5V10.5C10 10.7761 9.77614 11 9.5 11H8.5C8.22386 11 8 10.7761 8 10.5V5.5ZM9 14C9.55229 14 10 13.5523 10 13C10 12.4477 9.55229 12 9 12C8.44771 12 8 12.4477 8 13C8 13.5523 8.44771 14 9 14Z"
        fill={fill}
      />
    </svg>
  );
};

export default memo(Icon);
